module.exports = __webpack_public_path__ + "img/status-up.45407e19.svg";